export { RegistrationPageComponent } from './registration-page.component';
export { RegistrationPageModule } from './registration-page.module';
